import { soyshareApi } from '../../../../../services/api'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getFieldTypes: build.query({
      query: () => ({ url: `/field-types` }),
      providesTags: ['field-types']
    })
  })
})

export const { useGetFieldTypesQuery } = api
